import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'demand-by-domain-component',
  templateUrl: './demand-by-domain.component.html',
  styleUrls: ['./demand-by-domain.component.scss']
})
export class DemandByDomainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
